import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { AnalyticsService } from '@shared/services/analytics.service';
import { StateService } from '@shared/services';
import { ActivatedRoute, Router } from '@angular/router';
import { CustomizationModel } from '../../../models/customization.model';
import { CustomizationService } from '../../../services/customization.service';

@Component({
  selector: 'thevatra-form',
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FormComponent implements OnInit {
  public loginForm: FormGroup;
  public customConfig: CustomizationModel;
  public isSirius = false;

  constructor(public stateService: StateService,
              private router: Router,
              private route: ActivatedRoute,
              private fb: FormBuilder,
              public customizationService: CustomizationService,
              private cdr: ChangeDetectorRef) {
    this.customConfig = customizationService.config;
    this.isSirius = customizationService.isSirius();
  }

  ngOnInit(): void {
    const params = new URL(window.location.href).searchParams;
    const skip = params.get('skipPrejoin');
    const username = params.get('userName');
    this.initLoginForm(
      this.route.snapshot.paramMap.get('roomName') || this.stateService.roomName || '', username || this.stateService.userName || ''
    );
    if (skip) {
      this.stateService.isCamEnabled = true;
      this.stateService.isMicEnabled = true;
      this.onSubmit().then();
    }
    if (this.customConfig.isAuthEnabled) {
      this.loginForm.disable();
    }
  }

  protected initLoginForm(roomname: string, username = ''): void {
    this.loginForm = this.fb.group({
      roomName: [roomname, [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(50),
        Validators.pattern('^[a-zA-Z0-9-_]*$')
      ]],
      userName: [username, [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(50),
      ]],
    });
    this.loginForm.get('userName')?.valueChanges.subscribe((value) => {
      this.loginForm.get('userName')?.setValue(value.replace(/\s+/g, ' '), { emitEvent: false });
    });
  }

  isErrorVisible(field: string, error: string): boolean {
    return this.loginForm.controls[field].touched
      && this.loginForm.controls[field].errors
      && this.loginForm.controls[field].errors?.[error];
  }

  public async onSubmit(): Promise<void> {
    if(!this.loginForm.valid) {
      this.loginForm.markAllAsTouched();
      return;
    }
    AnalyticsService.addBreadcrumb('ui', 'Click join room in login.');
    const roomName: string = (this.loginForm.get('roomName') as FormControl).value;
    const userName: string = (this.loginForm.get('userName') as FormControl).value;
    this.stateService.userName = userName;
    this.stateService.startTime = Date.now();
    this.stateService.isLoggedIn = true;
    this.stateService.isPreviewStreamActive = true;
    const queryParams: { [key: string]: string } = {};
    if (this.route.snapshot.queryParams.userToken) {
      queryParams.userToken = this.route.snapshot.queryParams.userToken;
    }
    this.router.navigate(['/', roomName], { queryParams }).then();
  }

  isLegalChapter(event: any): boolean {
    if (/^[a-zA-Z0-9-_]*$/.test(event.key)) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }
}
